/* eslint-disable no-unused-vars */
import { Box, HStack, Text, useCheckbox } from "@chakra-ui/react";
import { useMemo } from "react";
import { normalizeDropdownOptions } from "../../utils/normalizeDropdownOptions";

function RadioStyleCheckbox(props) {
  const { getInputProps, getCheckboxProps, state } = useCheckbox(props);

  return (
    <Box as="label">
      <input {...getInputProps()} hidden />
      <Box
        {...getCheckboxProps()}
        cursor="pointer"
        borderWidth="1px"
        borderRadius="full"
        px={4}
        py={2}
        display="flex"
        alignItems="center"
        gap={2}
        transition="0.2s"
        _checked={{
          bg: "blue.500",
          color: "white",
          borderColor: "blue.600",
        }}
        _hover={{ borderColor: "blue.300" }}
        opacity={props.disabled ? 0.6 : 1}
        pointerEvents={props.disabled ? "none" : "auto"}
      >
        <Box
          w="12px"
          h="12px"
          borderRadius="full"
          borderWidth="2px"
          borderColor="currentColor"
          bg={state.isChecked ? "white" : "transparent"}
        />
        <Text>{props.children}</Text>
      </Box>
    </Box>
  );
}

export function MultiSelectRadio({
  options: rawOptions,
  value = [],
  onChange,
  spacing = 3,
  disabled,
}) {
  const options = useMemo(
    () => normalizeDropdownOptions(rawOptions, "MultiSelectRadio"),
    [rawOptions]
  );

  const toggle = (val) => {
    if (value.includes(val)) {
      onChange(value.filter((v) => v !== val));
    } else {
      onChange([...value, val]);
    }
  };

  return (
    <Box maxH="160px" overflowY="auto" overflowX="hidden" pr={2}>
      <HStack spacing={spacing} wrap="wrap">
        {options.map((opt) => (
          <RadioStyleCheckbox
            key={opt.value}
            isChecked={value.includes(opt.value)}
            onChange={() => toggle(opt.value)}
            disabled={disabled}
          >
            {opt.label}
          </RadioStyleCheckbox>
        ))}
      </HStack>
    </Box>
  );
}
